mutation updateGlobalMessage($data: GlobalMessageInput!) {
    updateGlobalMessage(data: $data)
}
